<script>
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  sourceAndDestinationType, orderType, slaType, defaultIndentCutOff, defaultArrivalCutOff,
  importExportType,
} from 'pando-constants';
import {
  orderTypes,
} from '@/modules-v2/indent/constants/order';

export default {
  methods: {
    /**
     * EDIT state methods
     */
    async bootStrapEditState(isEdit = false) {
      const orderResponse = await this.$store.dispatch(
        'order/find',
        { orderId: this.$route.params.orderId, isEdit },
      );
      if (!orderResponse.id) {
        this.$router.push({ name: 'OutboundIndentsV2' });
      }
      this.order = orderResponse;
      this.sourcesDropOffs = await this.contructSourcesDropoffs(orderResponse);
      this.previousTransporterId = orderResponse.transporter.id;
      // setting the other indent details
      this.currentOrderDetails = {
        ...this.currentOrderDetails,
        order_id: orderResponse.id,
        order_number: orderResponse.order_number,
        status: orderResponse.status,
        rfq: orderResponse.is_open_rfq,
        freightRate: orderResponse.base_frieght && orderResponse.base_frieght.freight_charge,
        freightType: orderResponse.freight_type,
        freight_unit: orderResponse.base_frieght.freight_unit,
        no_of_vehicles: orderResponse.no_of_vehicles,
        exim_type: orderResponse.exim_type,
        delayAutoSwitch: orderResponse.auto_switch_extended_once,
        extend_sla_by: orderResponse.extend_sla_by,
        contract_type: orderResponse.contract_type,
        transfer_type: orderResponse.transfer_type,
        indent_remarks: orderResponse.indent_remarks,
        /*
          PURCHASE ORDER FIELDS
        */
        purchaseOrderId: orderResponse.purchase_order_details ?
          orderResponse.purchase_order_details.po_id : null,
        po_number: {
          id: orderResponse.purchase_order_details ?
            orderResponse.purchase_order_details.po_id : null,
          po_number: orderResponse.purchase_order_details ?
            orderResponse.purchase_order_details.po_number : null,
        },
        po_line_number: {
          id: orderResponse.purchase_order_details ?
            orderResponse.purchase_order_details.po_id : null,
          po_line_number: orderResponse.purchase_order_details ?
            orderResponse.purchase_order_details.po_line_number : null,
        },
        account_assignment_number: {
          id: orderResponse.purchase_order_details ?
            orderResponse.purchase_order_details.po_id : null,
          account_assignment_number: orderResponse.purchase_order_details ?
            orderResponse.purchase_order_details.account_assignment_number : null,
        },
        selected_contracts: (orderResponse.destinations || []).map(destination => destination.contract && destination.contract.id),
        ...(orderResponse.ptl_info ? {
          no_of_materials: orderResponse.ptl_info.no_of_materials,
          material_weight: orderResponse.ptl_info.material_weight,
          material_volume: orderResponse.ptl_info.material_volume,
        } : {}),
      };
      if (orderResponse.shipment_number) {
        this.currentOrderDetails.shipment_number = orderResponse.shipment_number;
      }
      if (orderResponse.consider_return_freight_charge) {
        this.currentOrderDetails.consider_return_freight_charge = orderResponse.consider_return_freight_charge;
      }
      const orderTypeName = orderTypes.find(val => val.id === orderResponse.order_type);
      const orderTypeSuccess = await this.setOrderType(orderTypeName.name);
      if (orderTypeSuccess) {
        let canAddDetails = true;
        if ((this.isCreateFromDraftState || this.isFromCloneState) && this.isContract) {
          const hasContract = this.isInSelectedContract(orderResponse);
          if (!hasContract) {
            const userResponse = await this.openSwitchOpenIndentDialog();
            if (!userResponse) {
              this.sourcesDropOffs.forEach((source, sourceIndex) => {
                source.pickups.forEach((pickup, pickupIndex) => {
                  this.sourcesDropOffs[sourceIndex].pickups[pickupIndex].dropoffs = [];
                });
              });
              this.sourcesDropOffs = [...this.sourcesDropOffs];
              canAddDetails = false;
            } else {
              this.currentOrderDetails.freightRate = 0;
            }
          }
        }
        if (canAddDetails) {
          const transporterId = !this.currentOrderDetails.rfq ? orderResponse.transporter.id : [];
          this.currentOrderDetails = {
            ...this.currentOrderDetails,
            vehicleTypeId: orderResponse.vehicle_type.id,
            vehicleTypeName: orderResponse.vehicle_type.name, // ONLY used after assigned status
            transporterName: !this.currentOrderDetails.rfq ? orderResponse.transporter.name : '', // ONLY used after assigned status
            transporterId,
            deliveryType: orderResponse.vehicle_type.type,
            ...(orderResponse.vehicle && orderResponse.vehicle.number && !this.isFromCloneState ? {
              vehicle_number: orderResponse.vehicle.number.replace(/\s+/g, ''),
              vehicle_details_id: orderResponse.vehicle.id || null,
              vehicle_material_type: orderResponse.vehicle.material_type || null,
            } : {}),
          };
        }
      }
      // set IndentCutOff
      if ((this.order.order_type === orderType.CONTRACT ||
        this.order.order_type === orderType.OPEN) && this.sourcesDropOffs[0].type === sourceAndDestinationType.DEPOT) {
        await this.setDepotIndentCutOff(this.sourcesDropOffs[0].id, this.order.movement);
      }
      if (this.$hasFeature('resist_query_enhancer')) {
        this.currentOrderDetails.transporterName = orderResponse.transporter_name;
      }
      // set IndentCutOff
    },
    isInSelectedContract(currentIndent) {
      let validContract = false;
      const vehicleList = this.contractVehicles.filter(vehicle => vehicle.id === currentIndent.vehicle_type.id);
      if (vehicleList) {
        const hasTransporter = vehicleList.some(vehicle => vehicle.transporters.some(transporter => transporter.id === currentIndent.transporter.id) &&
          vehicle.type === currentIndent.vehicle_type.type);
        validContract = hasTransporter;
      }
      return validContract;
    },
    async contructSourcesDropoffs(orderData) {
      const result = [];
      // add sources
      orderData.sources.forEach((source, index) => {
        let sourceIndex = result.findIndex(val => val.id === source.location_id);

        let sourceDetails = {};
        if (sourceAndDestinationType.DEPOT === source.type) {
          sourceDetails = this.depots.find(val => val.id === source.location_id);
        } else if (sourceAndDestinationType.VENDOR_DEPOT === source.type) {
          sourceDetails.gates = [{
            id: source.gate_id,
            name: source.details.name,
            reference_id: source.details.reference_id,
          }];
        }
        if (sourceIndex === -1) {
          const sourceData = {
            type: source.type,
            id: source.location_id,
            name: source.details.name,
            reference_id: source.details.reference_id,
            gates: sourceDetails.gates &&
              sourceDetails.gates.filter(gate => !gate.is_virtual_gate),
            pickups: [],
          };
          result.push(sourceData);
        }
        sourceIndex = (sourceIndex === -1) ? result.length - 1 : sourceIndex;
        const dropoffsByGate = this.constructDropsForPickup(orderData, source);
        const gate = (sourceDetails.gates && sourceDetails.gates.find(val => val.id === source.gate_id)) || {};
        let pickupData = {
          name: gate.name,
          reference_id: gate.reference_id,
          vehicle_requirement_date: source.loading_date,
          loader_available: source.loader_available || false,
          add_to_invoice: source.add_to_invoice || false,
          dropoffs: dropoffsByGate,
        };
        if (source.sequence_number) {
          pickupData.sequence_number = source.sequence_number;
        }
        if (orderData && orderData.docks && orderData.docks.length) {
          const dbDocks = orderData.docks.map(dock => dock.id);
          const docks = (sourceDetails.docks && sourceDetails.docks.filter(dock => dbDocks.includes(dock.id))) || [];
          const dockId = docks.map(dock => dock.id);
          pickupData = { ...pickupData, ...{ dockId } };
        }
        if (this.isCreateFromDraftState || this.isFromCloneState) {
          pickupData.vehicle_requirement_date = new Date(); // replace the vehicle requirement date
        }
        if (pickupData && source.gate_id) {
          pickupData.id = source.gate_id;
        }
        result[sourceIndex].pickups.push(pickupData);
      });
      return result;
    },

    constructDropsForPickup(orderData, source) {
      // start of constructing drops for a gate/pickup
      const dropoffsByGate = orderData.destinations.filter((drop) => {
        if (drop.source_gate_id) {
          return drop.source_gate_id === source.gate_id;
        }
        return drop.source_location_id === source.location_id;
      });
      return dropoffsByGate.map((drop, index) => {
        let shipDropId = '';
        let shipDropParentId = '';
        let shipReferenceId = null;
        if (sourceAndDestinationType.DEPOT === drop.type) {
          const shipDetails = this.depots.find(val => val.gates.some(val => val.id === drop.gate_id));
          const gateDetails = shipDetails && shipDetails.gates.find(val => val.id === drop.gate_id);

          shipDropParentId = shipDetails.id;
          shipDropId = gateDetails.id;

          shipReferenceId = gateDetails.reference_id;
        } else if ([sourceAndDestinationType.DEPOT, sourceAndDestinationType.VENDOR_DEPOT].includes(drop.type)) {
          shipDropId = drop.gate_id;
          shipDropParentId = drop.location_id;
        } else {
          shipDropId = drop.location_id;
        }

        let soldDetails = drop.sold_details;
        if (sourceAndDestinationType.DEPOT === drop.type) {
          if (this.isEximIndent && orderData.exim_type === importExportType.IMPORT) {
            // ship to and sold to will be same in case of exim indent
            soldDetails = this.depots.find(val => val.gates.some(val => val.id === drop.gate_id));
            soldDetails.reference_id = soldDetails && soldDetails.gates.find(val => val.id === drop.gate_id).reference_id;
          } else {
            soldDetails = this.depots.find(val => val.gates.some(val => val.id === drop.sold_to_id));
            soldDetails.reference_id = soldDetails && soldDetails.gates.find(val => val.id === drop.sold_to_id).reference_id;
          }
        }

        let expectedDeliveryDate = drop.expected_delivery;

        if (this.isCreateFromDraftState || this.isFromCloneState) {
          if (this.order.order_type === orderType.OPEN) {
            expectedDeliveryDate = null; // clear the EDD date
          } else {
            expectedDeliveryDate = moment(new Date()).add(1, 'days');
          }
        }
        const shipTo = {
          id: shipDropId,
          location_id: shipDropParentId,
          reference_id: shipReferenceId || drop.details.reference_id,
          name: drop.details.name,
          type: drop.type,
        };
        if (drop.sequence_number) {
          shipTo.sequence_number = drop.sequence_number;
        }
        return { ship_to: shipTo,
          sold_to: {
            id: drop.sold_to_id,
            reference_id: soldDetails.reference_id,
            name: soldDetails.name,
          },
          unloader_available: drop.unloader_available || false,
          add_to_invoice: drop.add_to_invoice || false,
          expected_date: expectedDeliveryDate,
          booking_date: drop.booking_date || null,
          // PAN-43114: carry drop-level appointment id + per-drop delivered lock state
          appointment_id: drop.appointment_id || '',
          is_appointment_locked: !!(drop.reported_at && drop.release_at),
          index, // Needed to differentiate destination row items with same ship-to during update
        };
      });
      // end of constructing drops for a gate/pickup
    },
    async setDepotIndentCutOff(depotId, movement) {
      const payload = { depot_id: depotId, movement };
      const result = await this.$store.dispatch('settings/getIndentConfig', payload);
      this.indentCutOff = 0;
      this.indentArrivalCutOff = 0;
      if (result) {
        const isEnabled = this.isVehicleRequirementChangeByIndentCutOff(result);
        if (isEnabled) {
          const indentCutOffConfig = result.sla.find(_sla =>
            _sla.type === slaType.INDENT_CUTOFF);
          this.indentCutOff = indentCutOffConfig && indentCutOffConfig.duration ?
            indentCutOffConfig.duration : defaultIndentCutOff;

          const indentArrivalConfig = result.sla.find(_sla =>
            _sla.type === slaType.ARRIVAL_CUTOFF);
          this.indentArrivalCutOff = indentArrivalConfig && indentCutOffConfig.duration ?
            indentArrivalConfig.duration : defaultArrivalCutOff;
        }
      }
    },
    isVehicleRequirementChangeByIndentCutOff(config) {
      return config && config.update_vehicle_requirement_date_by_indent_cutoff;
    },
  },
};
</script>
